/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import { jsx as ___EmotionJSX } from "@emotion/core";
var SIZES = {
  small: 16,
  large: 32
};
export default function SpinnerSVG(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'small' : _ref$size,
    dataTestId = _ref.dataTestId,
    color = _ref.color;
  return ___EmotionJSX("svg", {
    viewBox: "0 0 176 176",
    width: "176",
    height: "176",
    preserveAspectRatio: "xMidYMid slice",
    "data-test-id": dataTestId + "-svg",
    "aria-label": "Loading spinner",
    style: {
      width: SIZES[size],
      height: SIZES[size],
      transform: 'translate3d(0px, 0px, 0px)',
      contentVisibility: 'visible'
    }
  }, ___EmotionJSX("defs", null, ___EmotionJSX("clipPath", {
    id: "__plurall_elo_spinner_element"
  }, ___EmotionJSX("rect", {
    width: "176",
    height: "176",
    x: "0",
    y: "0"
  }))), ___EmotionJSX("g", {
    clipPath: "url(#__plurall_elo_spinner_element)"
  }, ___EmotionJSX("g", {
    transform: "matrix(-2.655578851699829,0.5646723508834839,-0.5646723508834839,-2.655578851699829,-109.26936340332031,-40.08683776855469)",
    opacity: "1",
    style: {
      display: 'block'
    }
  }, ___EmotionJSX("g", {
    opacity: "1",
    transform: "matrix(1,0,0,1,-61.25899887084961,-61.25899887084961)"
  }, ___EmotionJSX("path", {
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    fillOpacity: "0",
    strokeMiterlimit: "4",
    stroke: color,
    strokeOpacity: "1",
    strokeWidth: "15.5",
    id: "__plurall_elo_loading_smile",
    d: " M22.0310001373291,5.656000137329102 C19.513999938964844,15.473999977111816 10.597999572753906,22.740999221801758 0,22.740999221801758 C-10.597999572753906,22.740999221801758 -19.513999938964844,15.473999977111816 -22.0310001373291,5.656000137329102"
  }))), ___EmotionJSX("g", {
    transform: "matrix(-0.9781172871589661,-0.20805427432060242,0.20805427432060242,-0.9781172871589661,155.76553344726562,192.38308715820312)",
    opacity: "1",
    style: {
      display: 'block'
    },
    id: "__plurall_elo_loading_circles"
  }, ___EmotionJSX("g", {
    opacity: "1",
    transform: "matrix(1,0,0,1,29.631999969482422,106.96499633789062)"
  }, ___EmotionJSX("path", {
    fill: color,
    fillOpacity: "1",
    d: " M-20.5,0 C-20.5,-11.321999549865723 -11.321999549865723,-20.5 0,-20.5 C11.321999549865723,-20.5 20.5,-11.321999549865723 20.5,0 C20.5,11.321999549865723 11.321999549865723,20.5 0,20.5 C-11.321999549865723,20.5 -20.5,11.321999549865723 -20.5,0z"
  })), ___EmotionJSX("g", {
    opacity: "1",
    transform: "matrix(1,0,0,1,88,149.3719940185547)"
  }, ___EmotionJSX("path", {
    fill: color,
    fillOpacity: "1",
    d: " M-20.5,0 C-20.5,-11.321999549865723 -11.321999549865723,-20.5 0,-20.5 C11.321999549865723,-20.5 20.5,-11.321999549865723 20.5,0 C20.5,11.321000099182129 11.321999549865723,20.5 0,20.5 C-11.321999549865723,20.5 -20.5,11.321000099182129 -20.5,0z"
  })), ___EmotionJSX("g", {
    opacity: "1",
    transform: "matrix(1,0,0,1,146.3679962158203,106.96499633789062)"
  }, ___EmotionJSX("path", {
    fill: color,
    fillOpacity: "1",
    d: " M-20.5,0 C-20.5,-11.321999549865723 -11.321000099182129,-20.5 0,-20.5 C11.321999549865723,-20.5 20.5,-11.321999549865723 20.5,0 C20.5,11.321999549865723 11.321999549865723,20.5 0,20.5 C-11.321000099182129,20.5 -20.5,11.321999549865723 -20.5,0z"
  })), ___EmotionJSX("g", {
    opacity: "1",
    transform: "matrix(1,0,0,1,124.072998046875,38.3489990234375)"
  }, ___EmotionJSX("path", {
    fill: color,
    fillOpacity: "1",
    d: " M-20.5,0 C-20.5,-11.321999549865723 -11.321000099182129,-20.5 0,-20.5 C11.321999549865723,-20.5 20.5,-11.321999549865723 20.5,0 C20.5,11.321999549865723 11.321999549865723,20.5 0,20.5 C-11.321000099182129,20.5 -20.5,11.321999549865723 -20.5,0z"
  })), ___EmotionJSX("g", {
    opacity: "1",
    transform: "matrix(1,0,0,1,51.92599868774414,38.3489990234375)"
  }, ___EmotionJSX("path", {
    fill: color,
    fillOpacity: "1",
    d: " M-20.5,0 C-20.5,-11.321999549865723 -11.321999549865723,-20.5 0,-20.5 C11.321999549865723,-20.5 20.5,-11.321999549865723 20.5,0 C20.5,11.321999549865723 11.321999549865723,20.5 0,20.5 C-11.321999549865723,20.5 -20.5,11.321999549865723 -20.5,0z"
  })))));
}
SpinnerSVG.propTypes = {
  dataTestId: PropTypes.string,
  color: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['small', 'large']).isRequired
};